const itemsReq = [
	{
		id: 1,
		key: 1,
		name: "status.approved"
	},
	{
		id: 3,
		key: 3,
		name: "status.rejected"
	},
	{
		id: 2,
		key:2,
		name: "status.waiting"
	}
];

export default itemsReq;